import { render, staticRenderFns } from "./ChangeMemberGradeCellTemplate.vue?vue&type=template&id=945bc3c8&"
import script from "./ChangeMemberGradeCellTemplate.vue?vue&type=script&lang=js&"
export * from "./ChangeMemberGradeCellTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports